import { FC } from "react";
import styled from "styled-components";
import { Spinner } from "../Spinner";
import { AccessibilityProps } from "../../AccessibilityProps";

const LoadingOverlayRoot = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

/** The `LoadingOverlay` component properties. */
interface LoadingOverlayProps extends Pick<AccessibilityProps, "aria-busy"> {
}

/** The loading overlay component. */
export const LoadingOverlay: FC<LoadingOverlayProps> = (props) => {
  const { "aria-busy": ariaBusy } = props;
  return (
    <LoadingOverlayRoot>
      <Spinner size="large" aria-busy={ariaBusy} />
    </LoadingOverlayRoot>
  );
};
